<template>
	<div class="mt-4">
		<v-card-title>
			<h2>Moje opinie formalne</h2>
		</v-card-title>
		<formal-evaluation-table/>
	</div>
</template>

<script>
	import FormalEvaluationTable from "./FormalEvaluationTable";

	export default {
		name: "FormalEvaluationList",
		components: {FormalEvaluationTable},
	};
</script>

<style scoped>

</style>
